import { OrderStatus, PaymentMethod } from 'constants/payment';
import { useAppSelector } from './redux';
import { getOrderSelector } from 'modules/ScrShopNew/store/slices/orders/selectors';
import { getPaymentMethod } from 'modules/ScrShopNew/store/slices/shop/selectors';

export const useIsRedirectToPaymentPage = () => {
  const paymentMethod = useAppSelector(getPaymentMethod);
  const { status } = useAppSelector(getOrderSelector);

  const isPaypalMethod = paymentMethod === PaymentMethod.PAYPAL;
  const isPaymentPending = status === OrderStatus.PAYMENT_PENDING;
  const isRedirectToPaymentPage = isPaypalMethod && isPaymentPending;

  return isRedirectToPaymentPage;
};
